export const APP_NAME = 'Customer Integration Hub' as const;
